import store from '@/store'

/**
 * GA / GTM 向けにストアのプロフィールからユーザーID文字列を生成する
 * @returns {string}
 */
export const getUserId4GA = () => {
  const userId = store.state.profile.user_id ?? ''
  const identificationCode = store.state.profile.identification_code ?? ''
  const integratedUserId = store.state.profile.integrated_user_id ?? ''

  if (identificationCode.startsWith('A')) {
    return identificationCode + '-' + userId
  }
  if (identificationCode.startsWith('S')) {
    const convertedCode = 'A' + identificationCode.substring(1)
    return convertedCode + '-S' + integratedUserId
  }
  return identificationCode + '-' + userId
}

/**
 * GTM クリックトリガー用: event は送らず uid のみ dataLayer に載せる
 * （GTM の Data Layer 変数 {{LC利用者ID}} 等が参照するキーは event と同じく uid）
 */
export const pushDataLayerUidForGtmClickTrigger = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ uid: getUserId4GA() })
}

/**
 * GTMログ送信（dataLayer.push。event と uid を送信）
 * @param {string} eventName イベント名
 */
export const gtmLog = (eventName, extraParams) => {
  window.dataLayer = window.dataLayer || []

  if (eventName) {

    const params = {
      'event': eventName,
      ...extraParams,
      'uid': getUserId4GA()
    }

    window.dataLayer.push(params)
  }
}
